import { getAvatarText } from '@/screens/Order/Pages/OrderOverview/components/TimeAndAction/components/TimeActionHeroPanel/TimeActionHeroPanel.helper'
import { PhoneOutlined, MailOutlined, UserOutlined } from '@ant-design/icons'
import { Avatar, Popover, Card, Row } from 'antd'
import Meta from 'antd/lib/card/Meta'
import { capitalize, find } from 'lodash'
import './OrderAvatarGroup.style.less'
type Props = {
  data: any
}

function OrderAvatarGroup({ data }: Props) {
  function checkURL(url) {
    return url ?? ''
  }

  return (
    <Avatar.Group
      maxCount={2}
      className="order-avatar-group-popver-name"
      maxStyle={{
        color: '#f56a00',
        backgroundColor: '#fde3cf',
      }}
    >
      {data &&
        data?.length &&
        data.map((avatar, i) => {
          return (
            <Popover
              key={i}
              placement="bottom"
              content={
                <Card className="p-2" bordered={false}>
                  <Meta
                    avatar={
                      <Avatar
                        src={`${avatar?.user?.avatar?.url_path}`}
                        alt={avatar?.user?.first_name}
                      >
                        {getAvatarText(
                          `${avatar?.user?.first_name || ''} ${
                            avatar?.user?.last_name || ''
                          }`.trim() || avatar?.user?.email || ''
                        )}
                      </Avatar>
                    }
                    title={`${avatar?.user?.first_name} ${avatar?.user?.last_name}`}
                  />
                  <p className="collab-popover-role">{`${capitalize(
                    avatar?.roles?.role
                  )}`}</p>
                  <div>
                    <h5>Contact</h5>
                    <Row
                      align={'middle'}
                      className="collab-popover-contact-container"
                    >
                      <PhoneOutlined /> &nbsp;
                      <a
                        href={`tel:${
                          avatar?.user?.property_value?.value?.length &&
                          find(avatar?.user?.property_value?.value, [
                            'key',
                            'phoneNumber',
                          ])?.value
                        }`}
                      >
                        {(avatar?.user?.property_value?.value?.length &&
                          find(avatar?.user?.property_value?.value, [
                            'key',
                            'phoneNumber',
                          ])?.value) ??
                          'N/A'}
                      </a>
                    </Row>
                    <Row
                      wrap={false}
                      align={'middle'}
                      className="collab-popover-contact-container"
                    >
                      <MailOutlined /> &nbsp;
                      <a href={`mailto:${avatar?.user?.email ?? ''}`}>
                        {avatar?.user?.email ?? ''}
                      </a>
                    </Row>
                  </div>
                </Card>
              }
            >
              <Avatar
                src={`${checkURL(avatar?.user?.avatar?.url_path)}`}
                alt={avatar?.user?.first_name}
                icon={<UserOutlined />}
              >
                {getAvatarText(
                  `${avatar?.user?.first_name || ''} ${
                    avatar?.user?.last_name || ''
                  }`.trim() || avatar?.user?.email || ''
                )}
              </Avatar>
            </Popover>
          )
        })}
    </Avatar.Group>
  )
}
export default OrderAvatarGroup
